import React from "react";
import { IconButton } from "@mui/material";
import { generateTestId } from "app/functions";

const HotIconButton = ({
  children,
  onClick,
  ariaLabel,
  position,
  top,
  right,
  left,
  width,
  height,
  color = "#000",
  backgroundColor,
  hoverColor,
  hoverOpacity,
  zIndex,
  flex,
  aspectRatio,
  maxWidth,
  padding = "8px",
  testID = "hot-icon-button",
  sx = {},
  ...rest
}) => {
  return (
    <IconButton
      aria-label={ariaLabel}
      onClick={onClick}
      testID={generateTestId(testID, "icon-button")}
      disableRipple
      sx={{
        position: position,
        top: top,
        right: right,
        left: left,
        width: width,
        height: height,
        color: color,
        backgroundColor: "transparent !important",
        zIndex: zIndex,
        flex: flex,
        aspectRatio: aspectRatio,
        maxWidth: maxWidth,
        padding: padding,
        "&:hover": {
          backgroundColor: "transparent !important",
          opacity: 1,
        },
        "&:active": {
          backgroundColor: "transparent !important",
        },
        "&:focus": {
          backgroundColor: "transparent !important",
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </IconButton>
  );
};

export default HotIconButton;

